'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";
import {evaluationAdmeliModel} from "../../models/evaluationadmelimodel.js";

export class InvitationEvaluationAdmeliCtrl extends EvaluationBaseCtrl
{
//	$scope;
//	$filter;
//	$timeout;
//	jsDataService;
//	notify;
//	evaluation = {};
	group = {
		admissibility: ['p1q1', 'p1q2', 'p1q3', 'p1q4', 'p1q5'],
		eligibility: ['p2q1', 'p2q2', 'p2q3', 'p2q4', 'p2q5', 'p2q6', 'p2q7', 'p2q8', 'p2q9']
	};
//	showRequire = false;
//	
//	constructor($scope, $filter, $timeout, jsDataService, notify){
//		'ngInject';
//		this.$scope = $scope;
//		this.$filter = $filter;
//		this.jsDataService = jsDataService;
//		this.notify = notify;
//		this.$timeout = $timeout;
//		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.evaluation = new evaluationAdmeliModel(jsDataService.get('evaluation', {}), $filter, jsDataService);
//		
//	}
	
	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new evaluationAdmeliModel(evaluation, this.$filter, this.jsDataService);
		
		this.changeUrl = this.jsDataService.get('changeUrl', '');
		this.cancelChangeUrl = this.jsDataService.get('cancelChangeUrl', '');
		this.pendingUrl = this.jsDataService.get('pendingUrl', '');
		this.confirmUrl = this.jsDataService.get('confirmUrl', '');
	}
	
	getQlist(name){
		let data = [];
		if(typeof(this.group[name]) === 'undefined'){
			return data;
		}
		for(let id of this.group[name]){
			let gr = this.evaluation.form_data.getQuestion(id);
			if(gr){
				data.push(gr);
			}
		}
		return data;
	}
	

	cancel = function(){
		const url = this.jsDataService.get('previewUrl');
		if(url){
			this.$scope.goUrl(url);
		}
	};

	save = function(){
		this.saveData();
	};

	saveData = function(){
		if(this.jsDataService.get('saveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('saveUrl'),
				method: 'POST',
				data: {
					questions: this.evaluation.form_data.questions,
					version: this.evaluation.form_data.version
				}
			}).then((response) => {

			});
	   }
	   return null;
   };

	change(){
		if(this.changeUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.changeUrl,
				method: 'GET'
			});
		}
	}

	pendingChange(ev){
		if(this.pendingUrl !== ''){
			const confirmTexts = this.jsDataService.get('pendingConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.pendingUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	confirm(ev){
		if(typeof(this.removeUrl) !== 'undefined' && this.confirmUrl !== ''){
			const confirmTexts = this.jsDataService.get('confirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.confirmUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	cancelChange(ev){
		if(typeof(this.cancelChangeUrl) !== 'undefined' && this.cancelChangeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cancelChangeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	publishChange(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.publishChangeDialogCtrl],
			templateUrl: 'invitations/publish_change.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {

			}
		}).then((results) => {
			if(typeof(this.item.status_url) !== 'undefined'){
				this.$scope.$root.basicHttpConfigProcess({
					url: this.item.status_url,
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}
		}, () => {});

	}

	publishDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectUrl')) !== 'undefined' && jsDataService.get('rejectUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishUrl')) !== 'undefined' && jsDataService.get('publishUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}

	publishChangeDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectChangeUrl')) !== 'undefined' && jsDataService.get('rejectChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishChangeUrl')) !== 'undefined' && jsDataService.get('publishChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}

	autosavePostFields() {
		this.saveData();
	}

}